import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import App from './App';
import {initializeAuthStore} from './lib/auth-token';

// Initialize the auth module with Redux store access
initializeAuthStore(() => store.getState());

const rootElement = document.getElementById('root') as HTMLElement;

const tree = (
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// The public pages arrive prerendered (scripts/prerender.mjs) and are hydrated in place; every other
// route gets the empty shell and renders from scratch.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  ReactDOM.createRoot(rootElement).render(tree);
}
